import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "@/pages/home/components/Hero";
import TopicFeed from "@/pages/home/components/TopicFeed";
import PkArena from "@/pages/home/components/PkArena";
import RemixSection from "@/pages/home/components/RemixSection";
import RulesAndFaq from "@/pages/home/components/RulesAndFaq";
import ContactSection from "@/pages/home/components/ContactSection";
import useSeo from "@/hooks/useSeo";
import { faqs } from "@/mocks/home";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.q,
    acceptedAnswer: { "@type": "Answer", text: faq.a },
  })),
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "吃瓜瓜田",
  url: "https://guatian-community.example/",
  description:
    "网爆黑料吃瓜群众聚集地，提供话题站队投票、观点 PK、评论互动与二创解读内容。",
  inLanguage: "zh-CN",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://guatian-community.example/?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "吃瓜瓜田",
  url: "https://guatian-community.example/",
  email: "editor@guatian-community.example",
  description: "一个倡导理性讨论的娱乐话题互动社区，禁止人肉、造谣与人身攻击。",
};

export default function Home() {
  const [showTop, setShowTop] = useState(false);
  const location = useLocation();

  useSeo({
    title: "网爆黑料_吃瓜群众站队投票|观点PK二创解读 - 吃瓜瓜田",
    description:
      "网爆黑料话题互动区，网爆黑料吃瓜群众聚集地。支持站队投票、观点PK、评论互动与二创解读，参与话题挑战，看看其他瓜友都站哪一边。",
    keywords: "网爆黑料,网爆黑料吃瓜群众,网爆黑料站队投票,网爆黑料观点PK,网爆黑料二创解读",
    canonicalPath: "/",
  });

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!location.hash) return;
    const target = document.querySelector(location.hash);
    if (target) {
      window.requestAnimationFrame(() => target.scrollIntoView({ behavior: "smooth", block: "start" }));
    }
  }, [location.hash]);

  return (
    <div id="top" className="min-h-screen w-full bg-background-50">
      <SiteHeader />

      <main className="w-full">
        <Hero />
        <TopicFeed />
        <PkArena />
        <RemixSection />
        <RulesAndFaq />
        <ContactSection />
      </main>

      <SiteFooter />

      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true" />
        </a>
      )}

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </div>
  );
}